import i18next from 'i18next';

import apiTaskTemplates from '@api/apiTaskTemplates';
import notificationService from '@utils/notificationService';
import Mixpanel from '@analytics/mixpanel';

export const FETCH_TASK_TEMPLATES_REQUEST = 'FETCH_TASK_TEMPLATES_REQUEST';
export const FETCH_TASK_TEMPLATES_SUCCESS = 'FETCH_TASK_TEMPLATES_SUCCESS';
export const FETCH_TASK_TEMPLATES_FAILURE = 'FETCH_TASK_TEMPLATES_FAILURE';
export const CREATE_TASK_TEMPLATE_SUCCESS = 'CREATE_TASK_TEMPLATE_SUCCESS';
export const DELETE_TASK_TEMPLATE_SUCCESS = 'DELETE_TASK_TEMPLATE_SUCCESS';

export const fetchTaskTemplates = (skip = 0, limit = 100, { silent = false } = {}) => async (dispatch) => {
  if (!silent) {
    dispatch({ type: FETCH_TASK_TEMPLATES_REQUEST });
  }
  try {
    const { data } = await apiTaskTemplates.listTemplates(skip, limit);
    const items = Array.isArray(data) ? data : data.items || [];
    const total = Array.isArray(data) ? data.length : data.total || items.length;

    dispatch({
      type: FETCH_TASK_TEMPLATES_SUCCESS,
      payload: { items, total },
    });
  } catch (error) {
    if (!silent) {
      dispatch({ type: FETCH_TASK_TEMPLATES_FAILURE, payload: error.message });
    }
    notificationService.error({ message: error.message });
  }
};

export const createTaskTemplate = (payload, { silent = false } = {}) => async (dispatch) => {
  try {
    const { data } = await apiTaskTemplates.createTemplate(payload);
    dispatch({ type: CREATE_TASK_TEMPLATE_SUCCESS, payload: data });
    if (!silent) {
      notificationService.success({
        message: i18next.t('message.templateCreated'),
      });
    }
    Mixpanel.track('Create task template');
    return data;
  } catch (error) {
    if (!silent) {
      notificationService.error({
        message: error?.response?.data?.errorMessage || error.message,
      });
    }
    return null;
  }
};

export const updateTaskTemplate = (id, payload) => async (dispatch) => {
  try {
    await apiTaskTemplates.updateTemplate(id, payload);
    notificationService.success({
      message: i18next.t('message.templateUpdated'),
    });
    Mixpanel.track('Update task template');
    dispatch(fetchTaskTemplates(0, 100, { silent: true }));
    return true;
  } catch (error) {
    notificationService.error({
      message: error?.response?.data?.errorMessage || error.message,
    });
    return false;
  }
};

export const deleteTaskTemplate = (id) => async (dispatch) => {
  try {
    await apiTaskTemplates.deleteTemplate(id);
    dispatch({ type: DELETE_TASK_TEMPLATE_SUCCESS, payload: { id } });
    notificationService.success({
      message: i18next.t('message.templateDeleted'),
    });
    Mixpanel.track('Delete task template');
    return true;
  } catch (error) {
    notificationService.error({
      message: error?.response?.data?.errorMessage || error.message,
    });
    return false;
  }
};
